/*
 * @Author: stevensh
 * @Date: 2020-02-28 17:39:00
 * @Last Modified by: stevensh
 * @Last Modified time: 2020-03-20 11:03:16
 */
import React, { FC } from 'react';
import { Route } from 'react-router-dom';

interface IProps {
  title?: string;
  parent?: any;
  component: any;
  path?: string;
  render?: any;
  page?: string;
  exact?: boolean;
}

const tit = process.env.REACT_APP_NAME_ENV;

const MyRoute: FC<IProps> = ({
  title,
  parent: Parent,
  component: Component,
  render,
  path,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={props => {
        document.title = tit || title || '默认title';
        if (Component && Parent) {
          return (
            <Parent>
              <Component {...props} />
            </Parent>
          );
        } else if (Component) {
          return <Component {...props} />;
        } else if (Parent) {
          return <Parent>{render(props)}</Parent>;
        } else {
          return render(props);
        }
      }}
    ></Route>
  );
};

export default MyRoute;
